import cache from './cache.js';
import getUserAgent from './getUserAgent.js';
import regex from './isAndroid.json';

export default cache('isAndroid', function isAndroid() {
  const pattern = new RegExp(...regex);
  return pattern.test(getUserAgent());
});